import { useTranslation } from 'react-i18next';

export const NewChat = () => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        height: '100%',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          width: '80%',
          height: '50%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          color: '#00000073',
          fontSize: '20px',
          fontWeight: 600,
          flexDirection: 'column',
          border: '1px solid #D9D9D9',
          borderRadius: '8px',
        }}
      >
        <p>{t('home.chat.newChat.content1')}</p>
        <p>{t('home.chat.newChat.content2')}</p>
        <br />
        <p>{t('home.chat.newChat.content3')}</p>
      </div>
    </div>
  );
};
